export default __webpack_public_path__ + "static/media/12.ad55614f.jpg";